import UnreviewedAppNotificationDescription from "../components/UnreviewedAppNotificationDescription";

const getUnreviewedAppNotificationDescription = (options) => {
  return <UnreviewedAppNotificationDescription options={options}/>
}

export default getUnreviewedAppNotificationDescription;